
import { showSnackbar } from 'utils/snack_bar/store/action';
import { actionTypes, CreateEpisodeInput, UpdateEpisodeInput, VideoEpisodeProps} from './actionType';
import { executeMutation, executeQuery } from 'utils/services/apiServices';
import { FETCH_EPISODES_BY_SEASON_ID } from '../graphql/query';
import { CREATE_EPISODE, DELETE_EPISODE, UPDATE_EPISODE } from '../graphql/mutation';

export const fetchVideoEpisodesRequest = () => ({
    type: actionTypes.FETCH_VIDEO_EPISODES_REQUEST
});

export const fetchVideoEpisodesSuccess = (payload: VideoEpisodeProps[]) => ({
    type: actionTypes.FETCH_VIDEO_EPISODES_SUCCESS,
    payload
});

export const fetchVideoEpisodesFail = (payload: string) => ({
    type: actionTypes.FETCH_VIDEO_EPISODES_FAIL,
    payload
});

export const fetchVideoEpisodes = (season_id:string) => {
    return async (dispatch: any) => {
        try {
            await dispatch(fetchVideoEpisodesRequest());
            const input = {
                season_id: season_id
            };
            const response = await executeQuery(FETCH_EPISODES_BY_SEASON_ID,input);
            const jsonData = response.data?.fetchEpisodesBySeasonId;
            if (jsonData?.error === null) {
                dispatch(fetchVideoEpisodesSuccess(jsonData?.data.episodes));
            } else {
                dispatch(fetchVideoEpisodesFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchVideoEpisodesFail('Failed to fetch VideoEpisode'));
        }
    };
};

//Create Episode
export const createVideoEpisodeSuccess= (payload: VideoEpisodeProps) => ({
    type: actionTypes.CREATE_VIDEO_EPISODE_SUCCESS,
    payload
});
export const createVideoEpisodeFail= (payload: string) => ({
    type: actionTypes.CREATE_VIDEO_EPISODE_FAIL,
    payload
});
export const createVideoEpisode = (input: CreateEpisodeInput) => {
    return async (dispatch: any) => {
        try {
            const inputData = {
                input:input
            }
            const response = await executeMutation(CREATE_EPISODE, inputData);
            const jsonData = response.data?.createEpisode;
            if (jsonData?.error === null) {
                dispatch(createVideoEpisodeSuccess(jsonData?.data.video_episode));
                 dispatch(showSnackbar('Success! episode created.'));
            } else {
                dispatch(createVideoEpisodeFail(jsonData?.error.message))
                 dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(createVideoEpisodeFail('Something went wrong, Try again later'))
        }
    };
};

//Update Episode
export const updateVideoEpisodeSuccess= (payload: VideoEpisodeProps) => ({
    type: actionTypes.UPDATE_VIDEO_EPISODE_SUCCESS,
    payload
});
export const updateVideoEpisodeFail= (payload: string) => ({
    type: actionTypes.UPDATE_VIDEO_EPISODE_FAIL,
    payload
});
export const updateVideoEpisode = (input: UpdateEpisodeInput) => {
    return async (dispatch: any) => {
        try {
            const inputData = {
                input:input
            }
            const response = await executeMutation(UPDATE_EPISODE, inputData);
            const jsonData = response.data?.updateEpisode;
            if (jsonData?.error === null) {
                dispatch(updateVideoEpisodeSuccess(jsonData?.data.video_episode));
                 dispatch(showSnackbar('Success! episode updated.'));
            } else {
                dispatch(updateVideoEpisodeFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
        dispatch(updateVideoEpisodeFail('Something went wrong, Try again later'))
        }
    };
};

//delete Episode
export const deleteVideoEpisodeSuccess= (payload: string) => ({
    type: actionTypes.DELETE_VIDEO_EPISODE_SUCCESS,
    payload
});
export const deleteVideoEpisodeFail= (payload: string) => ({
    type: actionTypes.DELETE_VIDEO_EPISODE_FAIL,
    payload
});
export const deleteVideoEpisode = (episode_id: string, folder_id: string) => {
    return async (dispatch: any) => {
        try {
            const inputData = {
                episode_id:episode_id,
                folder_id:folder_id
            }
            const response = await executeMutation(DELETE_EPISODE, inputData);
            const jsonData = response.data?.deleteEpisode;
            if (jsonData?.error === null) {
                dispatch(deleteVideoEpisodeSuccess(episode_id));
                dispatch(showSnackbar('Success! Package deleted.'));
            } else {
                dispatch(deleteVideoEpisodeFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(deleteVideoEpisodeFail('Something went wrong, Try again later'));
        }
    };
};



